import { slick } from 'slick-carousel';

export const ProductGalleryController = () => {
  if(!$('body').hasClass('single-products')) {
    return;
  }

  if($('.gallery-slider .slide').length <= 1) {
    return;
  }
  $('.gallery-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    asNavFor: '.thumbs-slider'
  });

  $('.thumbs-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.gallery-slider',
    dots: false,
    arrows: false,
    centerMode: true,
    focusOnSelect: true
  })
}



// WEBPACK FOOTER //
// ./src/js/controllers/ProductGalleryController.js